import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class TrabajadorService {
  async getTrabajadores() {
    const response = await fetchWrapper.get(`${ruta}/trabajador`);
    return response;
  }

  async getTrabajador(id) {
    const response = await fetchWrapper.get(`${ruta}/trabajador/${id}`);
    return response;
  }

  async getTrabajadoresActivos() {
    const response = await fetchWrapper.get(`${ruta}/trabajadores/activos`);
    return response;
  }

  async createTrabajador(datos) {
    const response = await fetchWrapper.post(`${ruta}/trabajador`, datos);
    return response;
  }

  async updateTrabajador(id, datos) {
    const response = await fetchWrapper.put(`${ruta}/trabajador/${id}`, datos);
    return response;
  }

  async deleteTrabajador(id) {
    return await fetchWrapper.delete(`${ruta}/trabajador/${id}`);
  }
}
